import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PendingEmailVerificationComponent } from './pending-email-verification/pending-email-verification.component';
import { IndexComponent } from './Index/Index.component';
import { SettingComponent } from './setting/setting.component';
import { PageVisitedHistoryComponent } from './page-visited-history/page-visited-history.component';
import { LoginHistoryComponent } from './login-history/login-history.component';
import { ProfileComponent } from './profile/profile.component';
import { MenuComponent } from './menu/menu.component';
import { RoleComponent } from './role/role.component';
import { HomeComponent } from './home.component';
import { AuthGuard } from '../_guards/auth.guard';
import { InformesIRMComponent } from './informes/irm/informes-irm.component';
import { InformesDLPComponent } from './informes/dlp/informes-dlp.component';
import { ClasificacionDeDatosComponent } from './administracion/clasificacion-de-datos/clasificacion-de-datos.component';
import { EtiquetasDeClasificacionComponent } from './administracion/etiquetas-de-clasificacion/etiquetas.component';
import { EtiquetasDeConfidencialidadComponent } from './administracion/etiquetas-de-confidencialidad/etiquetas-confidencialidad.component';
import { PanelDeCumplimientoComponent } from './administracion/panel-de-cumplimiento/panel-cumplimiento.component';
import { ProcedimientosComponent } from './manual/procedimientos/procedimientos.component';
import { ManualDeUsuarioComponent } from './manual/usuario/usuario.component';
import { DescargasComponent } from './informes/descargas/descargas.component';
import { CompañiasComponent } from './administracion/compañias/compañias.component';
import { CompañiaDetailComponent } from './administracion/compañia-detail/compañia-detail.component';
import { HelpComponent } from './help/help.component';
import { LogsComponent } from './informes/logs/logs.component';
import { FilesControlComponent } from './utilities/files-control/files-control.component';
import { FilesControlDetailComponent } from './utilities/files-control/details/files-control-detail.component';
import { InformesIAComponent } from './informes/ia/informes-ia.component';
import { CompanyDocumentsComponent } from './administracion/company-documents/company-documents.component';

const homeRoutes: Routes = [
  {
    path: 'home',
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    component: HomeComponent,
    children: [
      { path: 'index', component: IndexComponent },
      { path: '', redirectTo: '/home/index', pathMatch: 'full' },
      {
        path: 'pendingEmailVerification',
        component: PendingEmailVerificationComponent,
      },
      { path: 'setting', component: SettingComponent },
      { path: 'pageVisitedHistory', component: PageVisitedHistoryComponent },
      { path: 'loginHistory', component: LoginHistoryComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'menu', component: MenuComponent },

      { path: 'informes/dlp', component: InformesDLPComponent },
      { path: 'informes/irm', component: InformesIRMComponent },
      { path: 'informes/ia', component: InformesIAComponent },
      { path: 'informes/descargas', component: DescargasComponent },
      { path: 'informes/logs', component: LogsComponent },
      { path: 'informes/FilesControl', component: FilesControlComponent },
      {
        path: 'informes/FilesControl/:id',
        component: FilesControlDetailComponent,
      },

      {
        path: 'InformationProtection/SensitiveDataClassification',
        component: ClasificacionDeDatosComponent,
      },
      {
        path: 'MicrosoftPurview/DataClasification',
        component: ClasificacionDeDatosComponent,
      },
      {
        path: 'InformationProtection/SensitivityLabels',
        component: EtiquetasDeClasificacionComponent,
      },
      {
        path: 'MicrosoftPurview/DataClasify',
        component: EtiquetasDeClasificacionComponent,
      },
      {
        path: 'InformationProtection/DataLeakageDetectionDlp',
        component: EtiquetasDeConfidencialidadComponent,
      },
      {
        path: 'MicrosoftPurview/InformationProtection',
        component: EtiquetasDeConfidencialidadComponent,
      },
      {
        path: 'InformationProtection/InitialAudit',
        component: PanelDeCumplimientoComponent,
      },
      {
        path: 'InformationProtection/ContinuousImprovement',
        component: PanelDeCumplimientoComponent,
      },
      {
        path: 'InformationProtection/CompanyDocuments',
        component: CompanyDocumentsComponent,
      },
      {
        path: 'MicrosoftPurview/ComplianceManager',
        component: PanelDeCumplimientoComponent,
      },
      {
        path: 'InformationProtection/ComplianceManager',
        component: PanelDeCumplimientoComponent,
      },

      { path: 'Admin/Company', component: CompañiasComponent },
      { path: 'Admin/Company/edit/:id', component: CompañiaDetailComponent },

      { path: 'manual/procedures', component: ProcedimientosComponent },
      { path: 'manual/users', component: ManualDeUsuarioComponent },

      { path: 'help', component: HelpComponent },

      { path: 'role', component: RoleComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(homeRoutes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
